import {useI18n} from '@logistics-frontend/core/i18n'
import {Optional} from '@logistics-frontend/types'

import {DestinationPointDeliveryMethod, PickupStation, SourcePointDeliveryMethod} from 'src/shared/types'

import {isTerminal} from '../utils/is-terminal'
import {isWarehouse} from '../utils/is-warehouse'

export function usePointTitle(
  point: Optional<PickupStation>,
  pointType: SourcePointDeliveryMethod.DropOffPoint | DestinationPointDeliveryMethod.PickUpPoint,
) {
  const t = useI18n()

  if (point?.is_post_office) {
    return point.name
  }

  if (pointType === SourcePointDeliveryMethod.DropOffPoint && isWarehouse(point?.type)) {
    return t('ndd.dropoff_points.warehouse.label', 'Сортировочный центр')
  }

  if (isTerminal(point?.type)) {
    return t('ndd.pickup_points.terminal_type', 'Постамат')
  }

  if (pointType === SourcePointDeliveryMethod.DropOffPoint) {
    return t('ndd.pickup_points.dropoff_point_type', 'Пункт приёма')
  }

  return t('ndd.pickup_points.pickup_point_type', 'Пункт выдачи')
}
